import { cn } from "cn";
import { Checkbox } from "@/components/ui/checkbox";

/**
 * The select toggle in a tile's top-left corner. Where a pointer can hover it
 * hides until the tile (`group/attachment`) is hovered, and stays while the
 * file is selected; on a touch screen it always shows.
 */
export function AttachmentTileCheckbox({
  fileName,
  selected,
  onSelectedChange,
  dataTest,
}: {
  fileName: string;
  selected: boolean;
  onSelectedChange: (selected: boolean) => void;
  dataTest?: string;
}) {
  return (
    <Checkbox
      checked={selected}
      aria-label={`Select ${fileName}`}
      data-test={dataTest}
      onClick={(event) => event.stopPropagation()}
      onCheckedChange={(checked) => onSelectedChange(checked === true)}
      className={cn(
        /* sorted */
        "absolute top-2 left-2",
        "outline-solid outline-[1.5px] outline-outline-light shadow",
        "focus:outline-solid focus:outline-[1.5px] focus:outline-outline-light",
        "transition-opacity",
        !selected &&
          "group-hover/attachment:opacity-100 focus-visible:opacity-100",
        !selected && "pointer-fine:opacity-0",
      )}
    />
  );
}
